import React, { useCallback, useEffect, useRef, useState } from "react";

import api from "../../services/api";
import { notifyError } from "../../utils/notifications";
import EditModal from "./modal";
import * as Style from "./style";
import DataTableGroups from "./DataTableGroups";

function NewGroups() {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [openSSOModal, setOpenSSOModal] = useState(false);
  const [forceUpdate, setForceUpdate] = useState();

  const [selectedGroup, setSelectedGroup] = useState(null);

  const isFirstRender = useRef(true);

  async function newGroup() {
    setOpenModal(true);
    setSelectedGroup(null);
  }

  async function addRow(group) {
    setGroups((_p) => [..._p, group]);
    setSelectedGroup(group);
  }

  async function editRow(row) {
    setOpenModal(true);
    setSelectedGroup(row);
  }

  async function manageSSO(row) {
    setOpenSSOModal((prev) => !prev);
    setSelectedGroup(row);
  }

  const handleForceUpdate = () => {
    setForceUpdate((prev) => !prev);
  };

  async function getData() {
    try {
      setLoading(true);
      const { data } = await api.get("role");
      const permision = await api.get("permission", {
        module_id: 1,
        companie: data[0].company_id,
      });

      setPermissions(permision.data);
      setGroups(data);
    } catch (error) {
      notifyError("Falha ao listar permissões");
    } finally {
      setLoading(false);
    }
  }

  const getDataAfterSSOActivation = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get("role");

      setGroups(data);
    } catch (error) {
      notifyError("Falha ao listar permissões");
    } finally {
      setLoading(false);
    }
  }, [forceUpdate]);

  useEffect(() => {
    if (isFirstRender.current) {
      getData();
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getDataAfterSSOActivation();
  }, [forceUpdate]);

  return (
    <>
      <EditModal
        open={openModal}
        permissions={permissions}
        closeModal={() => {
          setOpenModal(false);
          setSelectedGroup(null);
        }}
        selectedGroup={selectedGroup}
        addRow={addRow}
      />

      <Style.Container data-testid="groups-page">
        {groups && (
          <DataTableGroups
            data={groups}
            loading={loading}
            modalAction={newGroup}
            editRow={editRow}
            fetchGroups={getDataAfterSSOActivation}
            setForceUpdate={handleForceUpdate}
            isModalVisible={openSSOModal}
            setIsModalVisible={manageSSO}
            selectedGroup={selectedGroup}
            setSelectedGroup={setSelectedGroup}
          />
        )}
      </Style.Container>
    </>
  );
}

export default NewGroups;
